import { Grid, MenuItem, Paper, Select, TextField } from "@material-ui/core";
import {
    createStyles, makeStyles,
    Theme
} from "@material-ui/core/styles";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Button from '@mui/material/Button';
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import {
    createDealer, getCities, getDealer,
    updateDealer
} from "../../actions/GenomicsResearchAction";


const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
        },
        table: {
            minWidth: 700,
        },
        content: {
            width: "80%",
            flexGrow: 21,
        },
        paper: {
            marginTop: "2rem",
            padding: "0.5rem 2rem 2rem 2rem",
            width: "100%",
        },
        hoveItem: {
            cursor: "pointer",
        },

        input: {
            padding: "1px",
        },
        tableContainer: {
            marginTop: "2rem",
            position: "sticky",
            top: "200px",
        },
        root1: {
            // backgroundColor: "#fa4d83",

        }
    })
);
interface Props {
    createDealer: any;
    getDealer: any;
    dealer: any;
    getCities: any;
    cities: any;
    dealerId: any;
    onBoardingActionType: any;
    updateDealer: any;

}
const StopsPlace: React.FC<Props> = ({
    createDealer,
    getDealer,
    dealer,
    getCities,
    cities,
    dealerId,
    onBoardingActionType,
    updateDealer,

}) => {
    const classes = useStyles();
    const history = useHistory();
    const [title, setTitle] = React.useState<any>("");
    const [firmName, setFirmName] = useState<any>("");
    const [gstNumber, setGstNumber] = useState<any>("");
    const [docContact, setDocContact] = useState<any>("")
    const [isEdit, setIsEdit] = useState<any>(false);
    const [editId, setEditId] = useState<any>("");
    const [doctorName, setDoctorName] = useState<any>("");
    const [gender, setGender] = useState<any>("");
    const { _id } = useParams<{ _id: string }>();
    const [docEmail, setDocEmail] = useState<any>([]);
    const [address, setAddress] = useState<any>("");
    const [city, setCity] = useState<any>("");
    const [cityName, setCityName] = useState<any>("");
    const [dealerAddress, setDealerAddress] = useState<any>("");
    const [panNumber, setPanNumber] = React.useState<any>("");
    const [mobileValidation, setMobileValidation] = useState({
        docContact: true,
    });
    const verifyMobile = (type: any) => {
        if (type === "mobile") {
            if (
                parseInt(docContact && docContact[0]) < 6 ||
                (docContact && docContact.length < 10)
            ) {
                setMobileValidation((prev: any) => ({
                    ...prev,
                    docContact: false,
                }));
            }
        }
    }
    const handleClientdata = async (e: any) => {
        e.preventDefault();
        const clientData = {
            salutation: title,
            name: doctorName,
            gender: gender,
            mobile: docContact,
            email: docEmail,
            city: city,
            firmName: firmName,
            address: dealerAddress,
            pan: panNumber,
            gstin: gstNumber,

        };
        const clientDataEdit = {
            salutation: title,
            name: doctorName,
            gender: gender,
            mobile: docContact,
            email: docEmail,
            city: city,
            firmName: firmName,
            address: dealerAddress,
            pan: panNumber,
            gstin: gstNumber,

        };
        if (gender === "") {
            delete clientData.gender;
        }
        if (title === "") {
            delete clientData.salutation;
        }
        if (docContact === "") {
            delete clientData.mobile;
        }
        if (doctorName === "") {
            delete clientData.name;
        }
        if (gstNumber === "") {
            delete clientData.gstin;
        }
        if (panNumber === "") {
            delete clientData.pan;
        }
        if (dealerAddress === "") {
            delete clientData.address;
        }
        if (city === "") {
            delete clientData.city;
        }
        if (isEdit) {
            await updateDealer(clientDataEdit, dealerId?._id);
        } else {
            await createDealer(clientData);
        }
        history.go(`/dashboard/gnre/dealer/create`);

    };
    useEffect(() => {
        getDealer();
        getCities();
    }, []);

    useEffect(() => {
        if (onBoardingActionType === "Edit Onboard Dealer") {
            setEditId(dealerId?._id);
            setTitle(dealerId?.salutation);
            setGender(dealerId?.gender);
            setDoctorName(dealerId?.name);
            setDocContact(dealerId?.mobile);
            setDocEmail(dealerId?.email)
            setAddress(dealerId?.institute_address);
            setCity(dealerId?.city?.id);
            setCityName(dealerId?.city?.display_name);
            setFirmName(dealerId?.firmName);
            setDealerAddress(dealerId?.address);
            setGstNumber(dealerId?.gstin);
            setPanNumber(dealerId?.pan);
            setIsEdit(true);
        }
    }, [onBoardingActionType])
    return (
        <Grid container spacing={2}>
            <form onSubmit={handleClientdata} style={{ width: "100%" }}>
                <Paper style={{ margin: "70px auto", width: "70%", background: "#eff", marginTop: 10 }} className={classes.root1}>
                    <h2 style={{ fontWeight: "bold", paddingTop: "20px", paddingBottom: "10px", textAlign: "center" }}>Fill Dealer Details</h2>
                    <Grid container spacing={2} style={{ marginLeft: 1 }}>
                        <Grid item xs={12} sm={4} >
                            <TextField
                                label="Dealer Firm Name"
                                variant="outlined"
                                className="input"
                                placeholder="Enter Firm Name"
                                fullWidth
                                value={firmName}
                                required
                                onChange={(e) => setFirmName(e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4} >
                            <TextField
                                label="Addesss"
                                variant="outlined"
                                className="input"
                                placeholder="Enter Firm Address"
                                fullWidth
                                value={dealerAddress}
                                onChange={(e) => setDealerAddress(e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <Autocomplete
                                key={isEdit}
                                id="City_Name"
                                onChange={(event, newValue) => {
                                    if (newValue) {
                                        let obj = JSON.parse(JSON.stringify(newValue, null, ""));
                                        setCity(obj.id);
                                    }
                                }}
                                defaultValue={
                                    { _id: "", name: cityName }
                                }
                                options={cities || []}
                                blurOnSelect
                                disableClearable={city===""}
                                disableCloseOnSelect
                                getOptionLabel={(option: any) => `${option?.name ? option?.name : ""}`}
                                onInputChange={(event, newInputValue) => {
                                    setCityName(newInputValue);
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        className="input"
                                        label="City"
                                        variant="outlined"
                                        placeholder="Select City"
                                        fullWidth
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <Select
                                className="input"
                                label="Salutation"
                                fullWidth
                                variant="outlined"
                                value={title || "none"}
                                style={{ width: "100%", height: "40px" }}
                                onChange={(e) => setTitle(e.target.value)}
                            >
                                <MenuItem value="none" disabled>Select Salutation</MenuItem>
                                <MenuItem value="Mr">Mr</MenuItem>
                                <MenuItem value="Ms">Ms</MenuItem>
                                <MenuItem value="Miss">Miss</MenuItem>
                                <MenuItem value="Master">Master</MenuItem>
                                <MenuItem value="Dr">DR.</MenuItem>
                            </Select>
                        </Grid>
                        <Grid item xs={12} sm={4} >
                            <TextField
                                label="Dealer Owner Name"
                                variant="outlined"
                                className="input"
                                placeholder="Enter Owner Name"
                                fullWidth
                                value={doctorName}
                                onChange={(e) => setDoctorName(e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4} >
                            <Select
                                className="input"
                                label="Gender"
                                fullWidth
                                variant="outlined"
                                value={gender || "none"}
                                style={{ width: "100%", height: "40px" }}
                                onChange={(e) => setGender(e.target.value)}
                            >
                                <MenuItem value="none" disabled>Select Gender</MenuItem>
                                <MenuItem value={"male"}>Male</MenuItem>
                                <MenuItem value={"female"}>Female</MenuItem>
                                <MenuItem value={"other"}>Other</MenuItem>
                            </Select>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <TextField
                                className="input"
                                name="Mobile Number"
                                label="Mobile Number"
                                type="number"
                                onInput={(e: any) => {
                                    e.target.value = Math.max(0, parseInt(e.target.value))
                                        .toString()
                                        .slice(0, 10);
                                }}
                                onWheel={(e: any) => e.target.blur()}
                                value={docContact || ""}
                                placeholder="Enter Mobile Number"
                                variant="outlined"
                                style={{ margin: "0", width: "100%" }}
                                onChange={(e) =>
                                    setDocContact(e.target.value as String)
                                }
                                onBlur={() => verifyMobile("mobile")}
                                onFocus={() => {
                                    setMobileValidation((prev: any) => ({
                                        ...prev,
                                        docContact: true,
                                    }));
                                }}
                                helperText={
                                    !mobileValidation.docContact &&
                                    "Incorrect Phone Number"
                                }
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <TextField
                                label="Email ID"
                                variant="outlined"
                                className="input"
                                placeholder="Enter Email ID"
                                fullWidth
                                value={docEmail}
                                required
                                onChange={(e) => setDocEmail(e.target.value.replace(/\s/g,''))}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <TextField
                                name="panNumber"
                                type="text"
                                value={panNumber}
                                className="input"
                                placeholder="Enter Pan Number"
                                label="PAN"
                                variant="outlined"
                                onChange={(e) =>
                                    setPanNumber(String(e.target.value).toUpperCase())
                                }
                                style={{ width: "100%" }}
                                helperText="Ex:- ABCDE9999F"
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <TextField
                                name="gstNumber"
                                type="text"
                                value={gstNumber}
                                placeholder="Enter Gst Number"
                                className="input"
                                label="GST NO."
                                variant="outlined"
                                onChange={(e) =>
                                    setGstNumber(String(e.target.value).toUpperCase())
                                }
                                style={{ width: "100%" }}
                            />
                        </Grid>
                    </Grid>
                    <Grid xs={12} style={{padding: "20px",textAlign:"center"}}>
                        <Button
                            color="primary"
                            variant="contained"
                            type="submit"
                            style={{ width: 300 }}

                        >
                            {isEdit ? "update" : "Save"}
                        </Button>
                    </Grid>
                </Paper>
            </form>
        </Grid >

    );
};
const mapStateToProps = (state: any) => ({
    dealer: state.GenomicsCAReducer.dealer,
    cities: state.GenomicsCAReducer.cities,

});
export default connect(mapStateToProps, {
    createDealer,
    updateDealer,
    getDealer,
    getCities,

})(StopsPlace);
